import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SyntageService {
    constructor(
        private http: HttpClient
    ) { }

    getInvoices(syntageUserId: any, sfAccountId: any, receiverName: any, paginate: any, term:any = null) {
        let url = `${environment.scs_url_lh}/portal/syntage/invoices?syntage_user_id=${syntageUserId}&sf_account_id=${sfAccountId}&receiver_name=${receiverName}`;
        if(term){
          url += `&term=${term}`;
        }
        if(paginate){
          url += `&page=${paginate.page}&size=${paginate.size}`;
        }
        return this.http.get<any>(url)
          .pipe(map(res => {
            return res;
          }));
    }

    getCreditLines(sfAccountId: any) {
        let url = `${environment.scs_url_lh}/portal/syntage/credit_lines?sf_account_id=${sfAccountId}`;
        return this.http.get<any>(url)
          .pipe(map(res => {
            return res;
          }));
    }

    registerSyntageUser(data: any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        let options = { headers: headers };

        return this.http.post<any>(environment.scs_url_lh + '/portal/syntage/register_user', data, options)
            .pipe(map(res => {
                return res;
              }));
    }

    getCreditNotes(invoiceId: any) {
        let url = `${environment.scs_url_lh}/portal/syntage/credit_notes?invoice_id=${invoiceId}`;
        return this.http.get<any>(url)
            .pipe(map(res => {
                return res;
            }));
    }

  updateInvoice(rfc: any, year: any, range: any) {
    let url = `${environment.scs_url_lh}/portal/syntage/sync_invoices?rfc=${rfc}&year=${year}&range=${range}`;
    return this.http.get<any>(url)
      .pipe(map(res => {
        return res;
      }));
  }
    

}
